export const ARTICLE_ID_PREFIX = "/api/articles/"
export const AI_AUTHOR_ID_PREFIX = "/api/ai-authors/"
export const CATEGORY_ID_PREFIX = "/api/categories/"

export const AUTHOR_ID_PREFIX = "/api/authors/"

export const DEBUG_COOKIE = "unife-debug"

export const USER_ID_UNKNOWN = 'UNKNOWN-USER-ID'
export const BODY_UNKNOWN = 'UNKNOWN-BODY'

export const DEFAULT_STICKY_HEADER_TOP_OFFSET = 340

